import {EAccountIsActive} from '../types/enum'

export const IS_ACTIVE_COLORS_MAP: Record<EAccountIsActive, string> = {
	[EAccountIsActive.active]:' bg-success',
	[EAccountIsActive.unactive]: 'bg-danger',
	// [EOfferScopeStatus.closed]: 'bg-danger',
	// [EOfferScopeStatus.active]: 'bg-success',
	// [EOfferScopeStatus.paused]: 'bg-warning',
	// [EOfferScopeStatus.none]: 'bg-grey',
}